import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const FolderFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                d="M5.89059 3.34667C6.07636 3.56098 6.18355 3.84951 6.18996 4.15249C6.18808 4.45177 6.28624 4.74038 6.46404 4.95832C6.55779 5.06995 6.67039 5.1582 6.79489 5.21761C6.91939 5.27701 7.05313 5.3063 7.18784 5.30368H13.3103C13.3353 5.30214 13.3604 5.30214 13.3855 5.30368C13.4679 5.30935 13.5485 5.33371 13.6228 5.37535C13.6971 5.417 13.7635 5.47511 13.8183 5.54638C13.8731 5.61765 13.9152 5.70068 13.9422 5.79071C13.9691 5.88075 13.9805 5.97604 13.9755 6.07113V6.76904H3.52307C2.84004 6.76904 2.24325 7.23048 2.07135 7.89153L1.001 12.0075V3.76876C0.999667 3.73988 0.999667 3.71093 1.001 3.68204C1.00592 3.58694 1.02703 3.4939 1.06313 3.40822C1.09922 3.32253 1.1496 3.2459 1.21138 3.18268C1.27316 3.11947 1.34513 3.07091 1.42317 3.03979C1.50122 3.00867 1.58382 2.99559 1.66625 3.00131H5.19208C5.45472 3.0087 5.70482 3.13236 5.89059 3.34667Z"
                fill={props.color}
            />
            <Path
                d="M3.03929 8.1432C3.09659 7.92286 3.29552 7.76904 3.5232 7.76904H14.7067C15.0339 7.76904 15.2729 8.07818 15.1906 8.39488L13.9607 13.1244C13.9034 13.3448 13.7044 13.4986 13.4768 13.4986H2.29329C1.96606 13.4986 1.72703 13.1894 1.80939 12.8727L3.03929 8.1432Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(FolderFilled);
